import Letterhead from "../Reusable/Letterhead2";
import MetaInfo from "../Reusable/MetaInfo2";
import SubjectLine from "../Reusable/SubjectLine2";
import Signature from "../Reusable/Signature2";

interface LowPerformanceWarningLetterProps{
    ref: string;
    name: string;
    date: string;
    address: string;
};


const LowPerformanceWarningLetter=({ref, name, date, address}: LowPerformanceWarningLetterProps)=>{
    return(
        <>
        <div className="p-10 rounded-lg max-w-2xl mx-auto space-y-4">
            <Letterhead/>
            <hr className=" mx-auto w-4/4 border-t-2 border-black"/>
            <MetaInfo refNo={ref} date={date} name={name} address={address} />
            <SubjectLine subject="Low Performance Warning Letter" />
        
            <p className="text-[20px] px-8" style={{fontFamily: "Times New Roman"}}>
            This letter serves as a written warning regarding your recent performance. It has been observed
            that your performance during your tenure has been consistently below the required and stated
            expectations.
            </p>
            <br/>
            <p className="text-[20px] px-8" style={{fontFamily: "Times New Roman"}}>
            The purpose of this warning letter is not to penalise you, but to highlight specific areas that
            require your attention and improvement.
            </p>
            <br/>
            <p className="text-[20px] px-8" style={{fontFamily: "Times New Roman"}}>
            We trust that you will take this matter seriously and make the necessary adjustments. We expect an immediate improvement in your performance, following company norms and standards. If
            inconsistency persists, it may lead to strict actions, including termination.
            </p>
            <br/>
            <p className="text-[20px] px-8" style={{fontFamily: "Times New Roman"}}>
            We believe in your potential and hope that with the right efforts and commitment, you can
            overcome this challenge and continue to contribute positively to our team.   
            </p>
        
            <Signature />
          </div>
        </>
    )
}
export default LowPerformanceWarningLetter;